import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import { Twitter, Facebook, Linkedin, Link2, Check } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

export const ShareModal = ({ open, onClose, url, title }) => {
  const [copied, setCopied] = useState(false);
  const text = `${title} — by Scott Burton Photography`;
  const enc = encodeURIComponent(url);
  const encText = encodeURIComponent(text);

  const targets = [
    { icon: Twitter, label: "X / Twitter", href: `https://twitter.com/intent/tweet?url=${enc}&text=${encText}`, id: "share-twitter" },
    { icon: Facebook, label: "Facebook", href: `https://www.facebook.com/sharer/sharer.php?u=${enc}`, id: "share-facebook" },
    { icon: Linkedin, label: "LinkedIn", href: `https://www.linkedin.com/sharing/share-offsite/?url=${enc}`, id: "share-linkedin" },
  ];

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link copied");
      setTimeout(() => setCopied(false), 2000);
    } catch { toast.error("Could not copy"); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="share-modal" className="max-w-md bg-obsidian-800 border-white/10">
        <DialogTitle className="sr-only">Share this frame</DialogTitle>
        <div className="overline-label">Share this frame</div>
        <h3 className="font-serif text-2xl font-light mt-1">Post it, link back here</h3>
        <p className="text-neutral-400 text-sm mt-1">Every share links straight back to this exact frame.</p>
        <div className="grid grid-cols-3 gap-3 mt-5">
          {targets.map((t) => (
            <a key={t.id} data-testid={t.id} href={t.href} target="_blank" rel="noreferrer"
              className="flex flex-col items-center gap-2 py-5 rounded-lg border border-white/10 hover:border-amber-glow/60 hover:text-amber-glow transition-colors">
              <t.icon size={20} />
              <span className="text-xs">{t.label}</span>
            </a>
          ))}
        </div>
        <div className="mt-4 flex items-center gap-2 border border-white/10 rounded-lg p-2">
          <input readOnly value={url} className="flex-1 bg-transparent text-xs text-neutral-400 px-2 outline-none" data-testid="share-url" />
          <button data-testid="share-copy" onClick={copy} className="btn-amber rounded px-3 py-2 text-sm flex items-center gap-1">
            {copied ? <Check size={14} /> : <Link2 size={14} />} {copied ? "Copied" : "Copy"}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
